import {TranslocoService} from '@ngneat/transloco';
import {DateUtil} from '../../../../util/date.util';
import {NumberUtil} from '../../../../util/number.util';
import {CommonCsvContentBuilder} from '../common-csv-content-builder';

export class ChildrenCsvContentBuilder extends CommonCsvContentBuilder {

    constructor(private data: any,
                private translocoService: TranslocoService) {
        super();
    }

    build(): string {
        return this.data.map(child => {
            const firstVisitInfo = this.getFirstVisitInfoForExportData(child);
            const {ageInYears, ageInMonths, birthDateFormatted} = this.convertAgeFormats(child.childBirthDateTimestamp);
            return [
                child.childName,
                child.province,
                child.county,
                child.organizationName,
                child.assistantUid,
                birthDateFormatted,
                ageInYears,
                ageInMonths,
                this.translateGender(child.gender),
                NumberUtil.toFixed(firstVisitInfo.muacNumber, 1),
                NumberUtil.toFixed(child.muac, 1),
                this.translateMarker(firstVisitInfo.marker),
                this.translateMarker(child.marker),
                firstVisitInfo.date,
                child.nextVisit,
                this.translateAlert(child.alert),
                this.translateBooleanCSVColumn(child?.childReferredToTheHospital),
                this.translateBooleanCSVColumn(child.transferredCase),
                child.token,
                `${child?.healthAssistants[0]?.firstName ?? ''} ${child?.healthAssistants[0]?.lastName ?? ''}`,
                child?.healthAssistants[0]?.province ?? '',
                child?.healthAssistants[0]?.county ?? '',
                child.childAddress,
                child.mothersName,
                child.mothersPhone,
                this.sanitizeText(child.chronicDisease),
                child.caregiverName,
                child.caregiverPhone
            ].join(';')
        }).join('\r\n');
    }

    translateTextCSVColumn(translationKey, dataToTranslate) {
        if (!dataToTranslate) {
            return '';
        }
        return this.translocoService.translateObject(translationKey);
    }

    translateBooleanCSVColumn(dataToTranslate) {
        if (dataToTranslate) {
            return this.translocoService.translateObject('yes');
        }
        return this.translocoService.translateObject('no');
    }

    getFirstVisitInfoForExportData(child) {
        let muacNumber = 0;
        let marker = '';
        let date = '';
        if (!child || !child.visits || !child.visits[0]) {
            return {muacNumber, marker, date};
        }
        const firstVisist = child.visits[0];
        if (firstVisist.muacNumber) {
            muacNumber = firstVisist.muacNumber;
        }
        if (firstVisist.marker) {
            marker = firstVisist.marker;
        }
        if (firstVisist.date) {
            date = DateUtil.format(firstVisist.date, 'DD/MM/YYYY');
        }
        return {muacNumber, marker, date};
    }

    private translateMarker(marker: string) {
        if (!marker) {
            return '';
        }
        return this.translateTextCSVColumn(
            `children.export.desnutritionLevel.${marker}`, marker
        );
    }

    private translateGender(gender: string) {
        if (!gender) {
            return '';
        }
        return this.translateTextCSVColumn(
            `children.export.gender.${gender.toLowerCase()}`, gender.toLowerCase(),
        );
    }

    private translateAlert(alert: any) {
        if (!alert) {
            return '';
        }
        return this.translateTextCSVColumn(
            `children.export.alert.${alert?.class}`, alert?.class
        );
    }

    private convertAgeFormats(childBirthDateTimestamp: number) {
        if (!childBirthDateTimestamp) {
            return {
                ageInYears: 0,
                ageInMonths: 0,
                birthDateFormatted: ''
            };
        }
        return {
            ageInYears: DateUtil.yearsDiff(new Date(childBirthDateTimestamp), new Date()),
            ageInMonths: DateUtil.monthsDiff(new Date(childBirthDateTimestamp), new Date()),
            birthDateFormatted: DateUtil.format(childBirthDateTimestamp, 'DD/MM/YYYY')
        };
    }

}
